<template>
    <span class="term-span inline-flex items-center">
        <span
            class="inline-flex h-6 leading-6"
            :class="{
                'border-b-2 border-eureka-500 bg-eureka-200': currentTerm?.id === termId,
            }"
            :data-term-id="termId"
        >{{ termText }}</span>
        <a
            v-if="showTermNumber && termNumber"
            class=" text-xs px-2 py-1 rounded"
            :class="{
                'text-white bg-eureka-500': currentTerm?.id === termId,
                'text-black bg-grey-20': currentTerm?.id !== termId,
            }"
        >{{ termNumber }}</a>
    </span>
</template>

<script setup lang="ts">
import { useTermNumberToggle } from '@telecom/shared/composables/use-term-number-toggle';
import { useSpecTerms } from '../confirm-claims-form/composables/use-spec-terms';

defineProps<{
    termId: string;
    termText: string;
    termNumber: string;
}>();

const { currentTerm } = useSpecTerms();
const { showTermNumber } = useTermNumberToggle();
</script>

<style>
@tailwind base;
@tailwind utilities;
</style>

